import { create } from "zustand";
import { devtools, subscribeWithSelector } from "zustand/middleware";

import type { IAuthStore } from "@/template/authManagement/authStore/types";
import { IAuthStepEnum } from "@/template/authManagement/authStore/types";

const initialState = {
  loginSide: true,
  whiteLogo: true,
  step: IAuthStepEnum.LOGIN,
  finalStep: IAuthStepEnum.LOGIN,
  loginMetaData: {
    userName: "",
    password: "",
  },
};

export const useAuthStore = create<IAuthStore>()(
  subscribeWithSelector(
    devtools(
      (set) => ({
        ...initialState,
        changeType: () => {},
        setLoginSide: (state) => {
          set({ loginSide: state });
        },
        setWhiteLogo: (state) => {
          set({ whiteLogo: state });
        },
        setStep: (state) => {
          set({ step: state });
        },
        setFinalStep: (state) => {
          set({ finalStep: state });
        },
        setLoginMetaData: (data) => {
          set({ loginMetaData: data });
        },
        resetState: () => {
          set({ ...initialState });
        },
      }),
      {
        enabled: !import.meta.env.PROD,
        name: "authStore",
      },
    ),
  ),
);
